export const CAMPAIGNS_TABLE = 'campaignsTable';
export const MARKDOWN = 'markdown';
export const METRIC = 'metric';
